import React from 'react';
import {
  Space,
  Text,
  Modal,
  ModalContent,
  Button,
  Conditional,
} from '@cashfree-intl/coherent';

import upperCase from 'lodash/upperCase';
import CustomIcons from 'components/CustomIcons';

import { CURRENCY_SYMBOL, INSTANT, STANDARD } from 'utils/constants';
// import { roundOffNumber } from 'utils/common';
import { roundOffNumber, titleCase } from 'utils/common';
import { StyledModalText, StyledModalContent } from './styled';
import { RefundInitiatedModalProps } from '../types';

import highlighter from '../../../images/highlighter.svg';

const RefundInitiatedModal = ({
  // instantRefundsFreeTrialEligibility,
  onActivateInstantly,
  data,
  closeModal,
  currency,
}: RefundInitiatedModalProps) => {
  const {
    requestedSpeed,
    currentSpeed,
    freeCreditsLeft,
    refundAmount,
    merchantAmount,
    freeTrialEligible,
    defaultSpeed,
    payload = {},
    // speedRejectionReason, // check if this is what will be shown
  } = data;

  const isInitiatedSuccessfully = requestedSpeed === currentSpeed;

  const showActivateInstantlySection =
    defaultSpeed !== upperCase(INSTANT) && currentSpeed === upperCase(INSTANT);

  const { is_split: isSplit, split_details: splitDetails = [] } = payload;

  return (
    <Modal open $maxWidth={480}>
      <ModalContent className="p-3 text-center">
        {/* Green tick here for Standard Refund */}
        <Conditional if={currentSpeed === upperCase(STANDARD)}>
          <CustomIcons
            componentName={
              isInitiatedSuccessfully ? 'GREEN_TICK_BIG' : 'FAILED'
            }
            size={isInitiatedSuccessfully ? '' : 'lg'}
          />
        </Conditional>
        <Conditional if={currentSpeed === upperCase(INSTANT)}>
          <CustomIcons
            componentName="ROCKET"
            type={isInitiatedSuccessfully ? 'success' : 'error'}
          />
        </Conditional>
        <StyledModalText variant="h20" className="mb-1">
          <Conditional if={isInitiatedSuccessfully}>
            {titleCase(requestedSpeed)} Refund Initiated Successfully!
          </Conditional>
          <Conditional if={!isInitiatedSuccessfully}>
            {titleCase(requestedSpeed)} Refund Failed!
          </Conditional>
        </StyledModalText>
        <Text>
          {freeTrialEligible
            ? 'Your customer account will be credited within a minute'
            : 'Refund Amount'}
        </Text>
        <StyledModalText
          variant="h16"
          strong
          color={isInitiatedSuccessfully ? 'success' : 'danger'}
          className="mb-3"
        >
          {currency} {refundAmount}
        </StyledModalText>
        <Conditional if={isSplit && splitDetails.length > 0}>
          <Space
            alignItems="center"
            justifyContent="space-between"
            className="mb-2 px-5"
          >
            <Text variant="b14" strong>
              Merchant Split Amount
            </Text>
            <Text variant="b14">
              {CURRENCY_SYMBOL.INR} {roundOffNumber(merchantAmount || 0)}
            </Text>
          </Space>
          <Text variant="b14" strong className="mb-1 text-left px-5">
            Vendor-wise Split Amount
          </Text>
          <Space direction="column" gap={1} className="mb-3 px-5">
            {splitDetails.map(obj => (
              <Space
                alignItems="center"
                justifyContent="space-between"
                key={obj.merchantVendorId}
              >
                <Text variant="b14" color="bodyLight">
                  {obj.merchantVendorId}
                </Text>
                <Text variant="b14" color="bodyLight">
                  {CURRENCY_SYMBOL.INR} {roundOffNumber(obj.amount || 0)}
                </Text>
              </Space>
            ))}
          </Space>
        </Conditional>
        <Conditional if={showActivateInstantlySection}>
          <StyledModalContent className="p-2">
            {/* Condition 1 */}
            {/* check this condition - combine with free trial eligible status api response */}
            <div className="text-left">
              <Conditional if={freeCreditsLeft > 0}>
                <Space alignItems="center" gap={1}>
                  <img src={highlighter} alt="Highlighter" />
                  <Text variant="b12">{freeCreditsLeft} Free Trials left</Text>
                </Space>
              </Conditional>
              <Text variant="h16" strong className="mt-2 mb-1">
                Set Instant as your default refund speed
              </Text>
              <Text color="bodyLight">
                Keep your customers worry-free by crediting their refunds in
                seconds. You can switch back to standard speed anytime from
                settings.
              </Text>
              <Space alignItems="center" gap={3} className="mt-3">
                <Button
                  primary
                  onClick={onActivateInstantly}
                  data-ignore-inner-text="true"
                  data-event-name="Primary_Button_Activate_Now"
                >
                  Activate Now
                </Button>
                <Button
                  className="p-0 link-button"
                  link
                  onClick={closeModal}
                  data-ignore-inner-text="true"
                  data-event-name="Link_Button_Later"
                >
                  Later
                </Button>
              </Space>
            </div>
            {/* Condition 2 */}
            {/* <Text color="bodyLight">
          We appreciate your patience as the customer&apos;s bank is
          experiencing a delay. We&apos;ll notify you once the refund is
          complete.
        </Text> */}
            {/* Condition 3 */}
            {/* <Conditional
            if={!isInitiatedSuccessfully && requestedSpeed === 'INSTANT'}
          >
            <Text className="mb-1">Initiating through Standard Refunds</Text>
            <Text color="bodyLight" variant="b12" className="w-500">
              We appreciate your patience as the customer&apos;s bank is
              experiencing a delay. We&apos;ll notify you once the refund is
              complete.
            </Text>
          </Conditional> */}
          </StyledModalContent>
        </Conditional>
        {/* Show for Condition 2 and 3 */}
        <Conditional if={!showActivateInstantlySection}>
          <Button
            link
            onClick={closeModal}
            data-ignore-inner-text="true"
            data-event-name="Link_Button_Okay"
          >
            Okay
          </Button>
        </Conditional>
      </ModalContent>
    </Modal>
  );
};

export default RefundInitiatedModal;
